import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import PaymentModal from "./PaymentModal";
import ReportImageModal from "./ReportImageModal";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import { getGraphData, getGraphDetails } from "../../api/api";
import GraphList from "./GraphList";
import CustomLoader from "../../common/loader/CustomLoader";
import GraphDetailsModal from "./GraphDetailsModal";
import { number } from "framer-motion";
import { PDFDocument } from "pdf-lib";
import toast from "react-hot-toast";
import { getBillIdWiseDownload } from "../../api/api";

const ShowReport = ({ reports, onBack }) => {
  const [openModal, setOpenModal] = useState(false);
  console.log("Reports in ShowReport:", reports);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showGraphList, setShowGraphList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const [graphDetails, setGraphDetails] = useState([]);
  const [graphModal, setGraphModal] = useState(false);
  const [userId, setUserId] = useState("");

  // Handle case when reports is undefined or empty

  if (!reports || reports.length === 0) {
    return (
      <Typography variant="body1" textAlign="center" mt={3}>
        No reports found.
      </Typography>
    );
  }

  const handlePayNow = () => {
    setOpenModal(true);
  };

  

const handleDownloadAllReports = async (reports) => {
  setLoading(true);

  try {
    const mergedPdf = await PDFDocument.create();
    let completed = 0;

    for (const report of reports) {
      if (!report.report_image_url) continue;

      try {
        // 🔥 SAFE BACKEND CALL
        const resp = await getBillIdWiseDownload({
          printUrl: report.report_image_url,
        });

        if (resp?.data?.status !== "success" || !resp.data.data) {
          throw new Error("Invalid PDF response");
        }

        let arrayBuffer;
        const fileData = resp.data.data;

        // ✅ Case 1: Base64 PDF
        if (typeof fileData === "string" && fileData.startsWith("data:")) {
          const base64 = fileData.split(",")[1];
          const byteChars = atob(base64);
          const byteNumbers = new Uint8Array(byteChars.length);

          for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
          }

          arrayBuffer = byteNumbers.buffer;
        }
        // ✅ Case 2: Backend URL
        else {
          const res = await fetch(fileData);
          arrayBuffer = await res.arrayBuffer();
        }

        const tempPdf = await PDFDocument.load(arrayBuffer);
        const copiedPages = await mergedPdf.copyPages(
          tempPdf,
          tempPdf.getPageIndices()
        );

        copiedPages.forEach((page) => mergedPdf.addPage(page));
      } catch (err) {
        console.error("Merge error:", err);
        toast.error("Some reports could not be downloaded");
      }

      completed++;
    }

    // 🔹 Create merged PDF
    const mergedPdfBytes = await mergedPdf.save();
    const mergedBlob = new Blob([mergedPdfBytes], {
      type: "application/pdf",
    });

    // 🔹 ZIP it
    const zip = new JSZip();
    zip.file("RB_All_Reports.pdf", mergedBlob);

    const zipBlob = await zip.generateAsync({ type: "blob" });

    const today = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");
    const patientName = reports[0]?.PatientName?.replace(/\s+/g, "_") || "Patient";

    saveAs(zipBlob, `${patientName}_${today}.zip`);
    toast.success("Reports downloaded successfully!");
  } catch (err) {
    console.error(err);
    toast.error("Failed to download reports");
  } finally {
    setLoading(false);
  }
};

  // Take bill-level details from the first object
  const billDetails = {
    billId: reports[0].BillID,
    billDate: reports[0].BillDate,
    netAmount: reports[0].NetAmt,
    dueAmount: reports[0].DueAmt,
    patientName: reports[0].PatientName,
    billPdfUrl: reports[0].Bill_pdf_url,
    patientName: reports[0].PatientName,
    user_id: reports[0].user_id,
    prescriptionUrl: reports[0].Prescription_pdf_url,
  };

  const handleOpenImageModal = (files) => {
    setSelectedFiles(files);
    setOpenImageModal(true);
  };

  const handleCloseImageModal = () => {
    setOpenImageModal(false);
    setSelectedFiles([]);
  };

  // Utility function: group by report_image_url
  const groupReportsByImage = (reports) => {
    const grouped = {};

    reports.forEach((test) => {
      if (test.report_image_url) {
        if (!grouped[test.report_image_url]) {
          grouped[test.report_image_url] = [];
        }
        grouped[test.report_image_url].push(test.TestName);
      }
    });

    return grouped;
  };
  const groupedReports = groupReportsByImage(reports);

  const fetchGraphData = async () => {
    setLoading(true);
    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        User_Id: billDetails.user_id,
      };
      const response = await getGraphData(payload);
      setGraphData(response?.data?.data || []);
      setShowGraphList(true);
      console.log("Graph Data:", response);
    } catch (error) {
      console.error("Error fetching graph data:", error);
    } finally {
      setLoading(false);
    }
  };

  const FetchGraphDetails = async (testData) => {
    console.log("Fetching graph details for test:", testData);
    setUserId(testData.User_ID);
    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: testData.User_ID.slice(-6),
      };
      setLoading(true);
      const response = await getGraphDetails(payload);
      const filterList = response?.data?.data;
      const filteredData = filterList.filter(
        (item) => item.CompoID === testData.CompoID
      );
      console.log("Filtered Graph Details:", filteredData);
      setGraphDetails(filteredData);
      setGraphModal(true);
    } catch (error) {
      console.error("Error fetching graph data:", error);
    } finally {
      setLoading(false);
    }
  };

  // const handleViewPdf = () => {
  //   const testName = graphDetails[0]?.TestName ;
  //   const patientId = userId;
  //   const url = `https://rb-api.in:4436/RBReports/RB_Patient_Data/GRAPH/${patientId}/${testName}.pdf`;
  //   window.open(url, "_blank");
  // }

  const handleViewPdf = () => {
    if (!graphDetails || graphDetails.length === 0) return;

    const rawTestName = graphDetails[0]?.TestName || "";
    const safeTestName = rawTestName.replace(/\s+/g, "_"); // replace spaces with "_"
    const patientId = userId;

    const url = `https://rb-api.in:4436/RBReports/RB_Patient_Data/GRAPH/${patientId}/${safeTestName}.pdf`;
    window.open(url, "_blank");
  };

  // if (loading) {
  //   return <CustomLoader />;
  // }

  return (
    <Box p={3}>
      {/* Top Card Section */}
      <Card
        sx={{
          mb: 3,
          borderRadius: 3,
          boxShadow: 3,
          bgcolor: "#E6F7F5",
          position: "relative",
        }}
      >
        {/* Top-left alert box */}
        {billDetails.dueAmount === "0.00" && (
        <Box
          sx={{
            position: "absolute",
            top: 16,
            left: 16,

            color: "#FF8C00",
            px: 2,
            py: 1,

            display: "flex",
            alignItems: "center",
            cursor: "pointer",

            zIndex: 10,
          }}
          onClick={() => {
            window.open(
              "https://rbdiagnostic.com/rb_merge_tabview/merge/frontview",
              "_blank"
            );
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Unable to find your past readings?{" "}
            <span style={{ textDecoration: "underline", color: "#0FB7A4" }}>
              Click here
            </span>
          </Typography>
        </Box>
        )}
        <CardContent>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item></Grid>
            {/* Patient Name */}
            <Grid item>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", textAlign: "center", color: "grey" }}
              >
                {billDetails.patientName}
              </Typography>
            </Grid>

            {/* Bill Info in a Row */}
            <Grid item xs={12}>
              <Grid container spacing={3} justifyContent="space-between">
                <Grid item>
                  <Typography variant="body2">
                    <strong>Bill Id :</strong> {billDetails.billId}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2">
                    <strong>Bill Date :</strong> {billDetails.billDate}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2">
                    <strong>Net Amt(Rs.) :</strong> {billDetails.netAmount}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2">
                    <strong>Due Amt(Rs.) :</strong> {billDetails.dueAmount}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Buttons Row */}
            <Grid item>
              <Grid container spacing={2} justifyContent="center">
                <Grid item>
                  <Button
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      bgcolor: "#0FB7A4",
                    }}
                    onClick={() => onBack()} // Call the onBack prop function
                  >
                    Search New
                  </Button>
                </Grid>
                {billDetails.dueAmount === "0.00" && (
                <Grid item>
                  <Button
                    variant="contained"
                    target="_blank"
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      bgcolor: "#0FB7A4",
                    }}
                    onClick={fetchGraphData}
                  >
                    View Graph
                  </Button>
                </Grid>
                )}
                <Grid item>
                  <Button
                    variant="contained"
                    href={billDetails.billPdfUrl}
                    target="_blank"
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      bgcolor: "#0FB7A4",
                    }}
                  >
                    View Bill
                  </Button>
                </Grid>
                <Grid item>
                  {billDetails.dueAmount > 0 && (
                    <Button
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        bgcolor: "#0FB7A4",
                      }}
                      onClick={handlePayNow}
                    >
                      Pay Now
                    </Button>
                  ) }
                   </Grid>
                  {billDetails.prescriptionUrl && (
                    <Button
                      variant="contained"
                      component="a"
                      href={encodeURI(billDetails.prescriptionUrl)}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        bgcolor: "#0FB7A4",
                      }}
                    >
                      View Rx
                    </Button>
                  )}
               
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Table Section */}
      <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#0FB7A4" }}>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Test Name
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Status
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Test Result
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Ref.Range
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                PACs
              </TableCell>

              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Graph/Img
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Report Image
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Reports
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map((test, idx) => (
              <TableRow
                key={idx}
                sx={{
                  backgroundColor: idx % 2 === 0 ? "#ffffff" : "#E6F7F5", // alternate light teal
                  "&:hover": { backgroundColor: "#D9F2EE" }, // slightly deeper on hover
                }}
              >
                <TableCell>{test.TestName || "-"}</TableCell>
                <TableCell>{test.ReportStatus || "-"}</TableCell>
                <TableCell>
                  {test.Test_Results?.length > 0
                    ? test.Test_Results.map((res, i) => (
                        <div key={i}>
                          {res.Component} - {res.TestResult}
                        </div>
                      ))
                    : "-"}
                </TableCell>
                <TableCell>
                  {test.Test_Results?.length > 0
                    ? test.Test_Results.map((res, i) => (
                        <div key={i}>{res.RefRange}</div>
                      ))
                    : "-"}
                </TableCell>

                <TableCell>
                  {test?.PacksLinkID && Number(test.PacksLinkID) !== 0 ? (
                    <Typography
                      component="a"
                      href={`https://rbdiagnostic.com/form?id=${btoa(
                        test.BillID
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        fontWeight: "bold",
                        color: "#0FB7A4",
                        textDecoration: "none",
                        cursor: "pointer",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      YES
                    </Typography>
                  ) : (
                    ""
                  )}
                </TableCell>

                <TableCell>
                  {test?.Attachment_url ? (
                    <a
                      href={test.Attachment_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      YES
                    </a>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell>
                  {test.Image_files_url?.length > 0 ? (
                    <Typography
                      sx={{
                        color: "#0FB7A4",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOpenImageModal(test.Image_files_url)}
                    >
                      YES
                    </Typography>
                  ) : (
                    "-"
                  )}
                </TableCell>
                {/* <TableCell>
                  {test.report_image_url ? (
                    <a
                      href={test.report_image_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                  ) : (
                    "-"
                  )}
                </TableCell> */}
                <TableCell>
                  {test.report_image_url ? (
                    <a
                      style={{
                        color: "#0FB7A4",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        // Scroll to last row in the table
                        const allRows =
                          document.querySelectorAll("table tbody tr");
                        if (allRows.length > 0) {
                          const lastRow = allRows[allRows.length - 1];
                          lastRow.scrollIntoView({ behavior: "smooth" });
                        }
                      }}
                    >
                      View
                    </a>
                  ) : (
                    "-"
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {/* {reports?.length > 0 &&
          !reports.some((item) => item.ReportStatus === "Pending") && ( */}
          {billDetails.dueAmount === "0.00" && (
            <Card sx={{ mt: 3, p: 2 }}>
              <Typography
                variant="h6"
                sx={{ color: "#0FB7A4", fontWeight: "bold", mb: 1 }}
              >
                View Report :{" "}
                <Typography
                  component="a"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    textDecoration: "none",
                    color: "#0FB7A4",
                    fontWeight: "normal",
                    ml: 1,
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() => handleDownloadAllReports(reports)}
                >
                  <DownloadIcon />
                  Download All Reports
                </Typography>
              </Typography>
              {/* {Object.entries(groupedReports).map(([url, testNames], idx) => (
            <Box
              key={idx}
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 1,
                color: "#0FB7A4",
              }}
            >
              
              <CheckCircleIcon fontSize="small" sx={{ mr: 1 }} />

             
              <Typography variant="body2" sx={{ flexGrow: 1 }}>
                {testNames.join(", ")}
              </Typography>

              
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#0FB7A4",  }}
              >
                <PictureAsPdfIcon fontSize="small" />
              </a>
            </Box>
          ))} */}

              {Object.entries(groupedReports).map(([url, testNames], idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 1,
                    color: "#0FB7A4",
                  }}
                >
                  {/* Green check icon */}
                  <CheckCircleIcon fontSize="small" sx={{ mr: 1 }} />

                  {/* Test names with PDF icon beside */}
                  <a
                    href={url}
                    download
                    style={{
                      color: "#0FB7A4",
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      {testNames.join(", ")}

                      {/* PDF Icon for download */}

                      <PictureAsPdfIcon fontSize="small" />
                    </Typography>
                  </a>
                </Box>
              ))}
            </Card>
          )}
      </TableContainer>

      {openModal && (
        <PaymentModal
          open={openModal}
          //   onClose={handleClose}
          billDetails={billDetails}
        />
      )}

      {openImageModal && (
        <ReportImageModal
          open={openImageModal}
          onClose={handleCloseImageModal}
          files={selectedFiles}
        />
      )}
      {showGraphList ? (
        <GraphList
          open={showGraphList}
          onClose={() => setShowGraphList(false)}
          data={graphData}
          patientName={billDetails.patientName}
          handleViewGraph={FetchGraphDetails}
        />
      ) : loading ? (
        <CustomLoader />
      ) : null}

      {graphModal && (
        <GraphDetailsModal
          open={graphModal}
          onClose={() => setGraphModal(false)}
          data={graphDetails}
          patientName={billDetails.patientName}
          handleViewPdf={handleViewPdf}
        />
      )}
    </Box>
  );
};

export default ShowReport;
